/**
 * BooleanInput with description
 *
 * Standard <BooleanInput> component extended with description
 *
 * @example
 *        import { BooleanInputWithDescription } from './components/BooleanInputWithDescription';
 *
 *        const SmapleParentComponent = (props) => (
 *          <BooleanInputWithDescription label="Publish now" source="publishNow">
 *            Check it if you would like to publish changes right away for every related website, otherwise,
 *            leave it unchecked and changes will be published with next cookie declaration update
 *          </BooleanInputWithDescription>
 *        );
 */

import React from 'react';
import { BooleanInput } from 'react-admin';
import Typography from '@material-ui/core/Typography';

export const BooleanInputWithDescription = ({ label, source, ...props }) => (
  <div>
    <BooleanInput label={label} source={source} className={props.className}/>
    <Typography variant="caption">
      {props.children}
    </Typography>
  </div>
);
